import { CommonModule } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  Inject,
  ViewChild,
} from '@angular/core';
import {
  MAT_DIALOG_DATA,
  MatDialogModule,
  MatDialogRef,
} from '@angular/material/dialog';

import { ContactFormComponent } from '@lockton-apps/shared/ui/contact-form';
import {
  ButtonModule,
  DialogModule,
  LinkDirective,
} from '@lockton-apps/shared/ui/lui';

/** @deprecated form dialog should be used instead */
@Component({
  selector: 'la-contact-create-dialog',
  imports: [
    CommonModule,
    DialogModule,
    ContactFormComponent,
    ButtonModule,
    LinkDirective,
    MatDialogModule,
  ],
  templateUrl: './contact-create-dialog.component.html',
  styleUrls: ['./contact-create-dialog.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ContactCreateDialogComponent {
  clientId: number;

  showLanguageControl = true;

  @ViewChild(ContactFormComponent) contactForm!: ContactFormComponent;

  constructor(
    @Inject(MAT_DIALOG_DATA) data: any,
    public dialogRef: MatDialogRef<ContactCreateDialogComponent>
  ) {
    this.clientId = data.clientId;
    this.showLanguageControl = data.showLanguageControl;
  }

  buttonClick() {
    this.contactForm && this.contactForm.ngForm.ngSubmit.emit();
  }

  addContact(contactModel: any) {
    this.dialogRef.close(contactModel);
  }
}
